import { nombrePais } from '@domino/schema'

// Las banderas del catálogo, como SVG servidos por CSS desde el paquete. Es la
// misma decisión que en la app de escritorio y por un motivo parecido: el emoji
// 🇺🇾 no cuesta nada pero no se dibuja en Windows, y buena parte de las visitas
// al site llegan desde una computadora del club.
//
// La diferencia con la app es que acá la hoja se pide aparte, y no con un
// `import` arriba. Son 249 banderas: 440 kB de CSS, más que todo el resto de la
// web junta. Con el import normal, Vite la mete en el archivo que bloquea el
// primer pintado, y en el wifi de un salón eso son segundos de pantalla vacía
// para dibujar un rectángulo de cinco milímetros. Pedida así queda en su propio
// archivo y llega cuando llega: las banderas aparecen un instante después que
// los nombres, que es exactamente el orden de importancia que tienen.
void import('flag-icons/css/flag-icons.min.css')

/**
 * La bandera del país de alguien, del tamaño de una línea de texto.
 *
 * Sin país no dibuja nada, ni un hueco: el campo es opcional y una columna de
 * placeholders grises se lee como un dato que falta y no como uno que no se
 * pidió.
 */
export function Bandera({ codigo }: { codigo: string | null }) {
  const nombre = codigo ? nombrePais(codigo) : null
  if (!codigo || !nombre) return null

  return (
    <span
      className={`bandera fi fi-${codigo.toLowerCase()}`}
      role="img"
      aria-label={nombre}
      title={nombre}
    />
  )
}
